/* lm-carrinho.js — tudo que acontece entre "adicionar" e "finalizar".

   1. Depois de adicionar, o cliente vai para a página do carrinho — lá ele
      decide entre finalizar a compra e continuar comprando.
   2. A barra fixa do celular, na página de produto, adiciona de verdade.
   3. Na página do carrinho, o − e o + salvam sozinhos.
*/
(function () {
  'use strict';

  /* ====================================================================
     1. Destino depois de adicionar
     ====================================================================
     MEDIDO: o POST para /cart/add já responde 302 para /cart. Isto só torna
     o destino explícito, gravando `return_to` no formulário — assim ele não
     depende do padrão da plataforma nem de um aplicativo que mude o caminho.
     Se o JS não rodar, o padrão da Shopify leva ao mesmo lugar.            */
  var DESTINO = '/cart';

  function marcar(form) {
    if (!form || form.dataset.lmDestino === '1') return;
    form.dataset.lmDestino = '1';
    if (form.querySelector('input[name="return_to"]')) return;
    var campo = document.createElement('input');
    campo.type = 'hidden';
    campo.name = 'return_to';
    campo.value = DESTINO;
    form.appendChild(campo);
  }

  function formsDeCompra(raiz) {
    return (raiz || document).querySelectorAll('form[action$="/cart/add"]');
  }

  /* ====================================================================
     2. Barra fixa do celular, na página de produto
     ====================================================================
     A barra só **rolava** a tela até o botão principal — o cliente clicava em
     "Adicionar à sacola" e nada ia para a sacola. Agora ela envia o formulário
     de compra de verdade, com a variante e a quantidade escolhidas.

     Por que em JavaScript e não trocando o `type` no Liquid: a barra fica
     fora do `{% form %}`, então ela não é botão de envio por conta própria.
     E não se perde nada sem JS — quem faz a barra aparecer é o
     IntersectionObserver da seção; sem JS ela nunca sai do `hidden`.        */
  function ligarBarra(raiz) {
    var botao = (raiz || document).querySelector('[data-lm-ir-comprar]');
    if (!botao || botao.dataset.lmEnvia === '1') return;

    var form = document.querySelector('form[action$="/cart/add"]');
    if (!form) return;

    botao.dataset.lmEnvia = '1';
    botao.addEventListener('click', function (e) {
      e.preventDefault();

      /* Envia *pelo* botão principal, e não só pelo formulário: assim o POST
         sai idêntico ao de quem clica lá em cima — inclusive o `name="add"`,
         que aplicativos de checkout usam para reconhecer a compra. */
      var principal = form.querySelector('[data-lm-comprar]:not([disabled])');
      if (typeof form.requestSubmit === 'function') form.requestSubmit(principal || undefined);
      else form.submit();
    });
  }

  /* ====================================================================
     3. Quantidade no carrinho, sem botão de atualizar
     ====================================================================
     O cliente pediu para tirar "Atualizar quantidades" e pôr − e + ao lado
     do número. Então o − e o + precisam salvar sozinhos.

     O envio é adiado meio segundo: quem clica três vezes no + recarrega a
     página uma vez, não três. O botão "Atualizar quantidades" continua no
     HTML como reserva para quem estiver sem JavaScript, mas quem esconde é
     o CSS da seção — se fosse aqui, ele piscaria na tela antes de sumir.    */
  var ESPERA = 500;
  var relogio = null;

  function enviarDepois(form) {
    clearTimeout(relogio);
    relogio = setTimeout(function () {
      var atualizar = form.querySelector('[data-lm-atualizar]');
      if (atualizar && typeof form.requestSubmit === 'function') form.requestSubmit(atualizar);
      else form.submit();
    }, ESPERA);
  }

  /* Se o cliente clicar em "Finalizar compra" dentro da meia-segundo de
     espera, esse envio manda junto os `updates[]` — a quantidade nova não se
     perde. O que não pode é o relógio disparar depois e trocar a ida para o
     checkout por uma volta ao carrinho. Por isso, todo envio o desarma. */
  function desarmarNoEnvio(form) {
    if (form.dataset.lmDesarma === '1') return;
    form.dataset.lmDesarma = '1';
    form.addEventListener('submit', function () { clearTimeout(relogio); });
  }

  function passo(botao) {
    var caixa = botao.closest('.lm-qtd');
    var campo = caixa && caixa.querySelector('[data-lm-qtd]');
    if (!campo) return;

    var atual = parseInt(campo.value, 10);
    if (isNaN(atual)) atual = 0;

    var novo = atual + parseInt(botao.dataset.lmPasso, 10);
    if (novo < 0) novo = 0;
    if (novo === atual) return;

    campo.value = novo;
    marcarLimites(caixa);

    var form = campo.form || campo.closest('form');
    if (form) enviarDepois(form);
  }

  /* Em 1, o − continua ativo: descer para 0 é como se remove pelo teclado. */
  function marcarLimites(caixa) {
    var campo = caixa.querySelector('[data-lm-qtd]');
    var menos = caixa.querySelector('[data-lm-passo="-1"]');
    if (campo && menos) menos.disabled = parseInt(campo.value, 10) <= 0;
  }

  function ligarCarrinho(raiz) {
    var caixas = (raiz || document).querySelectorAll('.lm-qtd');
    if (!caixas.length) return;

    caixas.forEach(function (caixa) {
      if (caixa.dataset.lmPronto === '1') return;
      caixa.dataset.lmPronto = '1';
      marcarLimites(caixa);

      var dono = caixa.closest('form');
      if (dono) desarmarNoEnvio(dono);

      caixa.querySelectorAll('[data-lm-passo]').forEach(function (b) {
        b.addEventListener('click', function () { passo(b); });
      });

      /* Digitar direto no campo também salva. */
      var campo = caixa.querySelector('[data-lm-qtd]');
      if (campo) {
        campo.addEventListener('change', function () {
          marcarLimites(caixa);
          var form = campo.form || campo.closest('form');
          if (form) enviarDepois(form);
        });
      }
    });
  }

  function varrer(raiz) {
    formsDeCompra(raiz).forEach(marcar);
    ligarBarra(raiz);
    ligarCarrinho(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { varrer(); });
  } else {
    varrer();
  }

  /* O editor de temas re-renderiza a seção: o que vier novo também entra. */
  document.addEventListener('shopify:section:load', function (e) { varrer(e.target); });
})();
